import React, { useState } from "react";
import TextField from '@mui/material/TextField';import {
  AdapterLuxonSunday
} from "../../../utils/AdapterSundayLuxon";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSnackbar } from 'notistack';
import { DateTime } from 'luxon';

const TeamDatesSelector = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const event = props.Event;

    const [arrivalDate, setArrivalDate] = useState( DateTime.fromISO(event?.BP_StartDate, { zone: 'utc' }));
    const [departureDate, setDepartureDate] = useState( DateTime.fromISO(event?.BP_EndDate, { zone: 'utc' }));

    // Parse event bounds once — normalize to Luxon DateTime
    const eventStart = event?.BP_StartDate ? DateTime.fromISO(event.BP_StartDate).startOf('day') : null;
    const eventEnd   = event?.BP_EndDate   ? DateTime.fromISO(event.BP_EndDate).endOf('day')     : null;

    const normalizeInput = (input) => {
        if (!input) return null;
        if (input instanceof DateTime) return input;
        if (input instanceof Date) return DateTime.fromJSDate(input);
        if (typeof input === 'string') return DateTime.fromISO(input);
        return null;
    };

    const isWithinEventBounds = (dt) => {
        if (!dt || !dt.isValid) return false;
        if (eventStart && dt < eventStart) return false;
        if (eventEnd   && dt > eventEnd)   return false;
        return true;
    };

   function handleDepartureDateChange(input) {
    const dt = normalizeInput(input);

    if (!dt || !dt.isValid) {
        enqueueSnackbar('Please select a valid departure date.', {
            variant: 'warning'
        });
        return;
    }

    if (!isWithinEventBounds(dt)) {
        enqueueSnackbar(
            `Departure date must be between ${eventStart?.toISODate()} and ${eventEnd?.toISODate()}.`,
            { variant: 'warning' }
        );
        return;
    }

    if (arrivalDate && dt < arrivalDate) {
        enqueueSnackbar(
            'Departure date cannot be before arrival date.',
            { variant: 'warning' }
        );
        return;
    }

    setDepartureDate(dt);

    props.onDatesChange({
        arrivalDate,
        departureDate: dt
    });
}

   function handleArrivalDateChange(input) {
    const dt = normalizeInput(input);

    if (!dt || !dt.isValid) {
        enqueueSnackbar('Please select a valid arrival date.', {
            variant: 'warning'
        });
        return;
    }

    if (!isWithinEventBounds(dt)) {
        enqueueSnackbar(
            `Arrival date must be between ${eventStart?.toISODate()} and ${eventEnd?.toISODate()}.`,
            { variant: 'warning' }
        );
        return;
    }

    // If arrival moves AFTER departure, clear departure
    if (departureDate && dt > departureDate) {
        setDepartureDate(null);

        props.onDatesChange({
            arrivalDate: dt,
            departureDate: null
        });

        enqueueSnackbar(
            'Departure date cleared because it must be after arrival.',
            { variant: 'info' }
        );
    } else {
        props.onDatesChange({
            arrivalDate: dt,
            departureDate
        });
    }

    setArrivalDate(dt);
}

    return (
        <div className="mb-4">
            <div className="full-row gray px-4 py-3 mb-4 rounded">
                <h5 className="mb-0 text-uppercase">Dates Attending</h5>
            </div>
            <div className="px-4 pb-3">
                <p className="mb-3">
                    Please select your dates within the event window
                    {eventStart && eventEnd && (
                        <span className="text-muted ms-1">
                            ({DateTime.fromISO(eventStart, { zone: 'utc' }).toLocaleString(DateTime.DATE_MED)} – {DateTime.fromISO(eventEnd, { zone: 'utc' }).toLocaleString(DateTime.DATE_MED)})

                        </span>
                    )}
                </p>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <LocalizationProvider dateAdapter={AdapterLuxonSunday}>
                            
<DatePicker
    slotProps={{
        textField: {
            id: "ReturnDate",
            fullWidth: true,
        },
    }}
    label="Start Date"
    value={arrivalDate}
    onChange={handleArrivalDateChange}
    // Arrival can't be before departure, and must be within event
    minDate={eventStart ?? undefined}
    maxDate={departureDate ?? eventEnd ?? undefined}
/>
                        </LocalizationProvider>
                        <small className="form-text text-muted">Enter your start date.</small>
                    </div>

                    <div className="col-md-6 mb-3">
                        <LocalizationProvider dateAdapter={AdapterLuxonSunday}>
                            
<DatePicker
    slotProps={{
        textField: {
            id: "DepartureDate",
            fullWidth: true,
        },
    }}
    label="End Date"
    value={departureDate}
    onChange={handleDepartureDateChange}
    // Constrain the calendar to event bounds
    minDate={arrivalDate ?? eventStart ?? undefined}
    maxDate={eventEnd ?? undefined}
/>
                        </LocalizationProvider>
                        <small className="form-text text-muted">Enter your end date.</small>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamDatesSelector;